/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Equipment, EquipmentInterface } from "../Equipment";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "assetIsNFT",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetOperators",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getMetadata",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "int256",
            name: "hitPoints",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "attack",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defense",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "percentChanceOfUse",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "numberOfUsesPerGame",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "createdAt",
            type: "bytes32",
          },
        ],
        internalType: "struct IGameEquipment.EquipmentMetadata",
        name: "equipment",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "idRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "metadata",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "int256",
        name: "hitPoints",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "attack",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "defense",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "percentChanceOfUse",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numberOfUsesPerGame",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "createdAt",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "int256",
        name: "hitPoints",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "attack",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "defense",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "percentChanceOfUse",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numberOfUsesPerGame",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Equipment__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Equipment> {
    return super.deploy(assetsAddress, overrides || {}) as Promise<Equipment>;
  }
  getDeployTransaction(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsAddress, overrides || {});
  }
  attach(address: string): Equipment {
    return super.attach(address) as Equipment;
  }
  connect(signer: Signer): Equipment__factory {
    return super.connect(signer) as Equipment__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EquipmentInterface {
    return new utils.Interface(_abi) as EquipmentInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Equipment {
    return new Contract(address, _abi, signerOrProvider) as Equipment;
  }
}
